import React, { useState, useEffect, useCallback } from 'react';
import { Users } from 'lucide-react';
import CreateUser from '../CreateUser';
import UserDetailsCompact from '../UserDetailsCompact';
import UsersList from '../../components/UsersList';
import useModalBackButton from '../../hooks/useModalBackButton';
import '../../styles/Management.css';
import { haptic } from '../../utils/vibration';
import { useInteractionPreferences } from '../../contexts/InteractionPreferencesContext';

const UsersManagement = () => {
  const { animationsEnabled } = useInteractionPreferences();
  const [showCreateUser, setShowCreateUser] = useState(false);
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // При выборе пользователя сохраняем логин для Header
  useEffect(() => {
    if (!showUserDetails || !selectedUser) {
      sessionStorage.removeItem('userDetailsLogin');
    }
  }, [showUserDetails, selectedUser]);

  useEffect(() => {
    if (!showCreateUser) {
      sessionStorage.removeItem('showCreateUser');
    }
  }, [showCreateUser]);

  const closeUserDetails = useCallback(() => {
    haptic('close');
    setShowUserDetails(false);
    setSelectedUser(null);
  }, []);

  useModalBackButton(Boolean(showUserDetails && selectedUser), closeUserDetails);

  // Слушаем событие возврата от Header
  useEffect(() => {
    window.addEventListener('userdetailsback', closeUserDetails);
    return () => window.removeEventListener('userdetailsback', closeUserDetails);
  }, [closeUserDetails]);

  // Слушаем возврат со страницы создания
  useEffect(() => {
    const handleBack = () => {
      haptic('close');
      setShowCreateUser(false);
    };
    window.addEventListener('createuserback', handleBack);
    return () => window.removeEventListener('createuserback', handleBack);
  }, []);

  return (
    <>
      {showCreateUser && (
        <CreateUser
          onBack={() => {
            haptic('close');
            setShowCreateUser(false);
          }}
          onUserCreated={() => {
            haptic('success');
            setShowCreateUser(false);
          }}
        />
      )}

      {showUserDetails && selectedUser && !showCreateUser && (
        <UserDetailsCompact
          user={selectedUser}
          onUserUpdated={() => {
            // Обновляем список пользователей после изменений
          }}
        />
      )}

      {!showCreateUser && !showUserDetails && (
        <div className={animationsEnabled ? "space-y-3 animate-fade-in desktop-content-container-wide" : "space-y-3 desktop-content-container-wide"}>
          <div className={animationsEnabled ? "bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden animate-slide-up" : "bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden"} style={animationsEnabled ? { animationDelay: '0.2s' } : {}}>
            <div className="p-4">
              <UsersList
                onViewUser={(user) => {
                  haptic('open');
                  setSelectedUser(user);
                  setShowUserDetails(true);
                  sessionStorage.setItem('userDetailsLogin', user.login || '');
                }}
                onCreateUser={() => {
                  haptic('open');
                  setShowCreateUser(true);
                  sessionStorage.setItem('showCreateUser', 'true');
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UsersManagement;
